import React from "react";
import { pdfjs, Document, Page } from "react-pdf";

export default function({ fileUrl, className, onLoad }) 
{
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
  
    return (
        <Document onLoadSuccess={onLoad} onLoadError={onLoad} className={`overflow-hidden w-auto h-full ${className ? className : ""}`} file={"https://www.genesis-analytics.com" + fileUrl}>
            <Page pageNumber={1} renderTextLayer={false} renderAnnotationLayer={false} />
        </Document>
    );
}
